import {extendsAPIServices} from "./APIServices";
import getEnv from "../../helpers/common/getEnv";
import {POST} from "../../constants/HTTPConstants";

const baseAdminAPI = getEnv('baseAdminAPI');
const api = extendsAPIServices(baseAdminAPI);


export const _appUpdateAvailable = () => {
    return api.makeAuthRequest({
        method: POST,
        url: `/app/update`
    });
};


// WEBPACK FOOTER //
// ./src/services/apis/AppServices.js